import { useState, useEffect } from 'react';
import styles from './AddToHomeScreen.module.css';

const AddToHomeScreen = () => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);
  
  useEffect(() => {
    // Daha önce gösterilip gösterilmediğini kontrol et
    const hasShownPrompt = localStorage.getItem('addToHomeScreenPromptShown');
    
    // iOS veya Android tarayıcısı olup olmadığını tespit et
    const ua = window.navigator.userAgent;
    const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    const webkit = !!ua.match(/WebKit/i);
    const isIOSDevice = iOS && webkit && !ua.match(/CriOS/i) && !ua.match(/OPiOS/i);
    
    const isAndroidDevice = /android/i.test(ua);
    
    setIsIOS(isIOSDevice);
    setIsAndroid(isAndroidDevice);
    
    // Eğer daha önce gösterilmediyse ve desteklenen bir cihazsa göster
    if (!hasShownPrompt && (isIOSDevice || isAndroidDevice)) {
      // Kullanıcı biraz gezindikten sonra göster
      const timer = setTimeout(() => {
        setShowPrompt(true);
      }, 30000); // 30 saniye sonra
      
      return () => clearTimeout(timer);
    }
  }, []);
  
  const handleDismiss = () => {
    setShowPrompt(false);
    // Bir daha göstermemek için localStorage'a kaydet
    localStorage.setItem('addToHomeScreenPromptShown', 'true');
  };
  
  if (!showPrompt) return null;
  
  return (
    <div className={styles.addToHomePrompt}>
      <div className={styles.promptContent}>
        <h3>Ana Ekranınıza Ekleyin</h3>
        <p>Daha hızlı erişim için vagonla'yı ana ekranınıza ekleyin</p>
        
        {isIOS && (
          <div className={styles.instructions}>
            <p>1. Safari'de, paylaşım butonuna <span className={styles.icon}>&#x25B2;</span> dokunun</p>
            <p>2. "Ana Ekrana Ekle" seçeneğine dokunun</p>
          </div>
        )}
        
        {isAndroid && (
          <div className={styles.instructions}>
            <p>1. Chrome'da, üç nokta menüsüne dokunun</p>
            <p>2. "Ana ekrana ekle" seçeneğine dokunun</p>
          </div>
        )}
        
        <button className={styles.dismissButton} onClick={handleDismiss}>
          Tamam, Anladım
        </button>
      </div>
    </div>
  );
};

export default AddToHomeScreen;
